import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=0ef7d94b&scoped=true"
import script from "./skeleton.vue?vue&type=script&lang=ts"
export * from "./skeleton.vue?vue&type=script&lang=ts"
import style0 from "./skeleton.vue?vue&type=style&index=0&id=0ef7d94b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef7d94b",
  null
  
)

export default component.exports